export default function RightArrow({ className }: { className?: string }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.5546 12.0314L9.29307 17.2929L10.7073 18.7071L17.4458 11.9686L10.6759 5.76283L9.32445 7.23714L14.5546 12.0314Z"
        fill="currentColor"
      />
    </svg>
  )
}
